import React from "react"
import { Wishlist} from "../../components"

const WishlistUser = () =>{
    return(
        <Wishlist/>
    )
}

export default WishlistUser